(function () {
  if (window.SwymWishlistSync) {
    return;
  }

  var STORAGE_KEY = 'swym:wishlist-sync';
  var EVENT_NAME = 'swym:wishlist-changed';
  var CHANNEL_NAME = 'swym-wishlist-sync';
  var BUTTON_SELECTOR = '.swym-wishlist-collections-v2, .swym-advanced-wishlist-collections, .swym-button, .swym-add-to-wishlist, .swym-added-to-wishlist, .atw-button, .atw-button-added, .swym-icon-text';
  var HEADER_COUNT_SELECTOR = '.swym-wishlist-header-counter, .swym-header-count';
  var PRODUCT_HOST_SELECTOR = [
    '[data-product-id]',
    '[data-empi]',
    '.card--default',
    '.product-card',
    '.st-product',
    '.product__row',
    '.product-gallery-block'
  ].join(', ');
  var PRODUCT_SCOPE_SELECTOR = [
    '[data-product-holder]',
    '[data-product-id]',
    '[data-empi]',
    '.card--default',
    '.product-card',
    '.st-product',
    '.card',
    '.product__row',
    '.product-gallery-block',
    '.product-form',
    '.product__page--info'
  ].join(', ');
  var BUTTON_CONTAINER_SELECTOR = [
    '.swym-btn-container',
    '.swym-wishlist-collections-v2-container',
    '.swym-advanced-wishlist-collections-container',
    '.swym-atw-button-container',
    '.swym-button-content',
    '.ws_product_wishlist_wrapper',
    '.ws_fbt_product',
    '.ws_fbt_product_Wrapper',
    '.ws_fbt_list_item',
    '.ws_fbt_card_wrapper'
  ].join(', ');
  var hasBroadcastChannel = typeof window.BroadcastChannel === 'function';
  var channel = hasBroadcastChannel ? new window.BroadcastChannel(CHANNEL_NAME) : null;
  var remoteListeners = [];
  var outboundBindings = new WeakSet();
  var methodsPatched = false;
  var observersStarted = false;
  var fetchInFlight = null;
  var lastState = createEmptyState();
  var lastFetchedAt = 0;
  var lastPlatformRefreshAt = 0;
  var refreshTimer = null;
  var notifyTimer = null;
  var refreshSequenceTimers = [];
  var clickEmitFallbackBound = false;
  var passiveRefreshInterval = null;
  var optimisticMutations = [];
  var OPTIMISTIC_MUTATION_TTL = 15000;

  function createEmptyState() {
    return {
      products: [],
      epis: {},
      empis: {},
      urls: {},
      handles: {},
      count: 0,
    };
  }

  function normalizeUrl(rawUrl) {
    if (!rawUrl) {
      return '';
    }

    try {
      var parsed = new URL(rawUrl, window.location.origin);
      parsed.hash = '';
      parsed.search = '';
      var pathname = parsed.pathname.replace(/\/+$/, '');
      return (pathname || '/').toLowerCase();
    } catch (error) {
      return String(rawUrl)
        .replace(/^https?:\/\/[^/]+/i, '')
        .replace(/[?#].*$/, '')
        .replace(/\/+$/, '')
        .toLowerCase();
    }
  }

  function normalizeHandle(rawUrl) {
    var normalizedUrl = normalizeUrl(rawUrl);
    var match = normalizedUrl.match(/\/products\/([^/]+)/i);
    return match && match[1] ? match[1].toLowerCase() : '';
  }

  function buildState(products) {
    var state = createEmptyState();
    state.products = Array.isArray(products) ? products : [];
    state.count = state.products.length;

    state.products.forEach(function (product) {
      if (product && product.epi != null) {
        state.epis[String(product.epi)] = true;
      }

      if (product && product.empi != null) {
        state.empis[String(product.empi)] = true;
      }

      if (product && product.du) {
        state.urls[normalizeUrl(product.du)] = true;
        var productHandle = normalizeHandle(product.du);
        if (productHandle) {
          state.handles[productHandle] = true;
        }
      }
    });

    return state;
  }

  function collectValues(target, keys) {
    var values = [];

    if (!target || typeof target !== 'object') {
      return values;
    }

    keys.forEach(function (key) {
      if (target[key] != null && target[key] !== '') {
        values.push(String(target[key]));
      }
    });

    return values;
  }

  function collectUrls(target, keys) {
    var values = [];

    if (!target || typeof target !== 'object') {
      return values;
    }

    keys.forEach(function (key) {
      var normalized = normalizeUrl(target[key]);
      if (normalized) {
        values.push(normalized);
      }
    });

    return values;
  }

  function normalizePayload(detail) {
    var sources = [];
    var product = detail && detail.product && typeof detail.product === 'object' ? detail.product : null;
    var nestedDetail = detail && detail.detail && typeof detail.detail === 'object' ? detail.detail : null;
    var nestedProduct = nestedDetail && nestedDetail.product && typeof nestedDetail.product === 'object' ? nestedDetail.product : null;

    [detail, nestedDetail, product, nestedProduct].forEach(function (item) {
      if (item && typeof item === 'object') {
        sources.push(item);
      }
    });

    var payload = {
      action: detail && detail.action === 'remove' ? 'remove' : 'add',
      epis: [],
      empis: [],
      urls: [],
      handles: [],
    };

    sources.forEach(function (item) {
      payload.epis = payload.epis.concat(
        collectValues(item, ['epi', 'variantId', 'productVariantId', 'swymVariantId', 'vid'])
      );
      payload.empis = payload.empis.concat(
        collectValues(item, ['empi', 'productId', 'swymProductId', 'pid'])
      );
      payload.urls = payload.urls.concat(
        collectUrls(item, ['du', 'url', 'productUrl', 'uri'])
      );
    });

    payload.epis = Array.from(new Set(payload.epis.filter(Boolean)));
    payload.empis = Array.from(new Set(payload.empis.filter(Boolean)));
    payload.urls = Array.from(new Set(payload.urls.filter(Boolean)));
    payload.handles = Array.from(new Set(payload.urls.map(normalizeHandle).filter(Boolean)));

    return payload;
  }

  function applyNormalizedPayloadToState(state, payload) {
    if (!state || !payload) {
      return;
    }

    if (payload.action === 'remove') {
      payload.epis.forEach(function (value) {
        delete state.epis[value];
      });
      payload.empis.forEach(function (value) {
        delete state.empis[value];
      });
      payload.urls.forEach(function (value) {
        delete state.urls[value];
      });
      payload.handles.forEach(function (value) {
        delete state.handles[value];
      });
    } else {
      payload.epis.forEach(function (value) {
        state.epis[value] = true;
      });
      payload.empis.forEach(function (value) {
        state.empis[value] = true;
      });
      payload.urls.forEach(function (value) {
        state.urls[value] = true;
      });
      payload.handles.forEach(function (value) {
        state.handles[value] = true;
      });
    }

    state.products = (state.products || []).filter(function (product) {
      var productUrl = normalizeUrl(product && product.du);
      var productHandle = normalizeHandle(product && product.du);
      var productEpi = product && product.epi != null ? String(product.epi) : '';
      var productEmpi = product && product.empi != null ? String(product.empi) : '';
      var matches = payload.epis.indexOf(productEpi) >= 0 ||
        payload.empis.indexOf(productEmpi) >= 0 ||
        (productUrl && payload.urls.indexOf(productUrl) >= 0) ||
        (productHandle && payload.handles.indexOf(productHandle) >= 0);

      if (payload.action === 'remove') {
        return !matches;
      }

      return true;
    });

    state.count = Math.max(
      0,
      Object.keys(state.epis).length ||
      Object.keys(state.empis).length ||
      Object.keys(state.urls).length ||
      Object.keys(state.handles).length ||
      state.products.length
    );
  }

  function rememberOptimisticMutation(payload) {
    if (!payload || (!payload.epis.length && !payload.empis.length && !payload.urls.length)) {
      return;
    }

    optimisticMutations = optimisticMutations.filter(function (entry) {
      return Date.now() - entry.timestamp < OPTIMISTIC_MUTATION_TTL;
    });

    optimisticMutations.push({
      timestamp: Date.now(),
      payload: {
        action: payload.action,
        epis: payload.epis.slice(),
        empis: payload.empis.slice(),
        urls: payload.urls.slice(),
        handles: payload.handles.slice(),
      },
    });
  }

  function applyOptimisticMutations(state) {
    optimisticMutations = optimisticMutations.filter(function (entry) {
      return Date.now() - entry.timestamp < OPTIMISTIC_MUTATION_TTL;
    });

    optimisticMutations.forEach(function (entry) {
      applyNormalizedPayloadToState(state, entry.payload);
    });
  }

  function updateStateFromPayload(detail) {
    var payload = normalizePayload(detail);

    if (payload.epis.length === 0 && payload.empis.length === 0 && payload.urls.length === 0) {
      return payload;
    }

    applyNormalizedPayloadToState(lastState, payload);
    rememberOptimisticMutation(payload);

    return payload;
  }

  function dispatch(detail) {
    var payload = Object.assign(
      {
        timestamp: Date.now(),
      },
      detail || {}
    );

    updateStateFromPayload(payload);
    updateButtonsFromState(lastState);
    updateHeaderCount(lastState);

    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload }));
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload }));

    remoteListeners.forEach(function (listener) {
      try {
        listener(payload);
      } catch (error) {
        console.error('Swym wishlist sync listener failed', error);
      }
    });

    return payload;
  }

  function broadcast(payload) {
    if (channel) {
      try {
        channel.postMessage(payload);
      } catch (error) {
        console.error('Failed to broadcast wishlist message', error);
      }
    }

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
      /* Ignore private-mode and quota failures. */
    }
  }

  function emit(detail) {
    var payload = dispatch(detail);
    broadcast(payload);
    scheduleRefreshSequence([80, 450, 1200, 2200]);
    return payload;
  }

  function scheduleUiRefresh(forceFetch) {
    clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      if (window._swat) {
        refreshPageState(window._swat, !!forceFetch);
      }
    }, forceFetch ? 80 : 180);
  }

  function clearRefreshSequence() {
    refreshSequenceTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    refreshSequenceTimers = [];
  }

  function scheduleRefreshSequence(delays) {
    if (!window._swat) {
      return;
    }

    clearRefreshSequence();

    (delays || [80, 450, 1200, 2200]).forEach(function (delay) {
      var timer = window.setTimeout(function () {
        refreshPageState(window._swat, true);
      }, delay);

      refreshSequenceTimers.push(timer);
    });
  }

  function hasWishlistHosts() {
    return !!document.querySelector(PRODUCT_HOST_SELECTOR);
  }

  function refreshPlatformCollections() {
    if (!window._swat || !_swat.collectionsApi || typeof _swat.collectionsApi.initializeCollections !== 'function') {
      return;
    }

    if (!document.body || !hasWishlistHosts()) {
      return;
    }

    if (Date.now() - lastPlatformRefreshAt < 800) {
      return;
    }

    lastPlatformRefreshAt = Date.now();

    try {
      _swat.collectionsApi.initializeCollections(_swat, false);
    } catch (error) {
      console.error('Failed to refresh Swym collection buttons', error);
    }
  }

  function fetchWishlistState(swat, options) {
    var shouldForce = options && options.force;
    var hasFreshCache = !shouldForce && lastFetchedAt && Date.now() - lastFetchedAt < 1500;

    if (hasFreshCache) {
      return Promise.resolve(lastState);
    }

    if (fetchInFlight && !shouldForce) {
      return fetchInFlight;
    }

    fetchInFlight = new Promise(function (resolve) {
      swat.fetch(function (products) {
        lastState = buildState(products);
        applyOptimisticMutations(lastState);
        lastFetchedAt = Date.now();
        fetchInFlight = null;
        resolve(lastState);
      });
    });

    return fetchInFlight;
  }

  function findFirstProductLink(target) {
    if (!target || typeof target.querySelector !== 'function') {
      return null;
    }

    return target.querySelector('a[href*="/products/"], a.card__img--container[href], a.card__title[href]');
  }

  function getDatasetProductUrl(target) {
    if (!target || !target.dataset) {
      return '';
    }

    return target.dataset.productUrl || target.dataset.url || target.dataset.du || '';
  }

  function getClosestProductContext(element) {
    if (!(element instanceof Element)) {
      return null;
    }

    return element.closest(PRODUCT_SCOPE_SELECTOR);
  }

  function findNearbyProductContext(element) {
    if (!(element instanceof Element)) {
      return null;
    }

    var directContext = getClosestProductContext(element);
    if (directContext) {
      return directContext;
    }

    var current = element.parentElement;
    var depth = 0;

    while (current && depth < 4) {
      var nestedContext = current.querySelector(PRODUCT_SCOPE_SELECTOR);
      if (nestedContext) {
        return nestedContext;
      }

      current = current.parentElement;
      depth += 1;
    }

    return null;
  }

  function getClosestProductLink(element, scope) {
    var directLink = element.closest('a[href*="/products/"]');
    if (directLink && directLink.getAttribute) {
      return directLink.getAttribute('href');
    }

    var contexts = [];
    var closestProductContext = findNearbyProductContext(element);

    if (scope) {
      contexts.push(scope);
    }

    if (closestProductContext && contexts.indexOf(closestProductContext) === -1) {
      contexts.push(closestProductContext);
    }

    var buttonContainer = element.closest(BUTTON_CONTAINER_SELECTOR);
    if (buttonContainer && contexts.indexOf(buttonContainer) === -1) {
      contexts.push(buttonContainer);
    }

    if (element.parentElement && contexts.indexOf(element.parentElement) === -1) {
      contexts.push(element.parentElement);
    }

    for (var i = 0; i < contexts.length; i += 1) {
      var datasetUrl = getDatasetProductUrl(contexts[i]);
      if (datasetUrl) {
        return datasetUrl;
      }

      var candidate = findFirstProductLink(contexts[i]);
      if (candidate && candidate.getAttribute) {
        return candidate.getAttribute('href');
      }
    }

    return '';
  }

  function isWithinSelectorList(element, selectors) {
    if (!(element instanceof Element) || !Array.isArray(selectors)) {
      return false;
    }

    return selectors.some(function (selector) {
      return !!element.closest(selector);
    });
  }

  function isWithinWiserFbt(element) {
    return isWithinSelectorList(element, [
      '.evm-also-bought-products',
      '.ws_fbt_inr_main_wgt',
      '.ws_fbt_widget_design',
      '.ws_fbt_wrapper',
      '.ws_fbt_wrap',
      '.ws_fbt_card_wrapper',
      '.ws_fbt_layout1',
      '.ws_fbt_layout2',
      '.ws_fbt_layout3',
    ]);
  }

  function getClosestIdentityScope(element) {
    if (!(element instanceof Element)) {
      return null;
    }

    if (isWithinWiserFbt(element)) {
      var outerWiserProductScope = element.closest([
        '.ws_fbt_product',
        '.ws_fbt_product_Wrapper',
        '.ws_fbt_list_item',
        '.ws_fbt_card_wrapper',
      ].join(', '));

      if (outerWiserProductScope) {
        return outerWiserProductScope;
      }

      var innerWiserProductScope = element.closest([
        '.ws_card_wrapper',
        '.ws_card',
        '.ws_product_wishlist_wrapper',
      ].join(', '));

      if (innerWiserProductScope) {
        return innerWiserProductScope;
      }

      return element.closest([
        '.ws_fbt_wrapper',
        '.ws_fbt_wrap',
        '.ws_fbt_widget_design',
        '.ws_fbt_inr_main_wgt',
        '.evm-also-bought-products',
      ].join(', '));
    }

    return element.closest([
      PRODUCT_SCOPE_SELECTOR,
      BUTTON_CONTAINER_SELECTOR
    ].join(', '));
  }

  function collectAncestorDatasets(element, stopNode) {
    var datasets = [];
    var current = element;

    while (current && current !== document.documentElement) {
      if (current.dataset) {
        datasets.push(current.dataset);
      }

      if (stopNode && current === stopNode) {
        break;
      }

      current = current.parentElement;
    }

    return datasets;
  }

  function collectCachedIdentityValues(element, keys, target) {
    if (!target || !target.dataset) {
      return;
    }

    [
      target.dataset.swymResolvedEpi,
      target.dataset.swymWishlistEpi,
      target.dataset.swymEpi,
    ].forEach(function (value) {
      if (value != null && value !== '') {
        keys.epis.push(String(value));
      }
    });

    [
      target.dataset.swymResolvedEmpi,
      target.dataset.swymWishlistEmpi,
      target.dataset.swymEmpi,
    ].forEach(function (value) {
      if (value != null && value !== '') {
        keys.empis.push(String(value));
      }
    });

    [
      target.dataset.swymResolvedDu,
      target.dataset.swymWishlistDu,
      target.dataset.swymDu,
    ].forEach(function (value) {
      var normalized = normalizeUrl(value);
      if (normalized) {
        keys.urls.push(normalized);
      }
    });
  }

  function cacheProductKeysOnElement(target, keys) {
    if (!target || !target.dataset || !keys) {
      return;
    }

    if (keys.epis && keys.epis[0]) {
      target.dataset.swymResolvedEpi = keys.epis[0];
    }

    if (keys.empis && keys.empis[0]) {
      target.dataset.swymResolvedEmpi = keys.empis[0];
    }

    if (keys.urls && keys.urls[0]) {
      target.dataset.swymResolvedDu = keys.urls[0];
    }
  }

  function cacheProductKeys(element, keys) {
    if (!(element instanceof Element) || !keys) {
      return;
    }

    var targets = [
      element,
      element.closest(BUTTON_CONTAINER_SELECTOR),
      findNearbyProductContext(element),
      getClosestIdentityScope(element),
    ].filter(Boolean);

    targets.forEach(function (target) {
      cacheProductKeysOnElement(target, keys);
    });
  }

  function shouldUseProductPageFallback(element, keys) {
    if (!document.body.classList.contains('template--product')) {
      return false;
    }

    if (isWithinWiserFbt(element)) {
      return false;
    }

    var excludedSelectors = [
      '.ws-widget-section',
      '.ws_card_wrapper',
      '.ws_card',
      '.ws_inr_main_wgt',
      '.ws_fbt_wrap',
      '.cbb-also-bought-container',
      '.card--default',
      '.product-card',
      '.product-mini',
      '.st-product',
      '.snize-product',
      '.swymcs-wishlistplus-item',
    ];

    if (isWithinSelectorList(element, excludedSelectors)) {
      return false;
    }

    var currentProductUrl = normalizeUrl(window.location.href);
    var hasExplicitProductIdentity = keys.epis.length > 0 || keys.empis.length > 0;
    var hasNonPdpUrl = keys.urls.some(function (url) {
      return url && url !== currentProductUrl;
    });

    if (hasExplicitProductIdentity || hasNonPdpUrl) {
      return false;
    }

    var includedButtonSelectors = [
      '.product-gallery-block .swym-icon-text',
      '.product-gallery-block .swym-button-content .swym-icon-text',
      '.product-gallery-block .swym-atw-button-container.product_image_top_right .atw-button',
      '.product-gallery-block .swym-atw-button-container.product_image_top_right .atw-button-added',
      '.add-to-cart__sticky .swym-icon-text',
      '.add-to-cart__sticky .atw-button',
      '.add-to-cart__sticky .atw-button-added',
      '.sticky--mobile .swym-icon-text',
      '.sticky--mobile .atw-button',
      '.sticky--mobile .atw-button-added',
    ];

    return includedButtonSelectors.some(function (selector) {
      return !!element.matches(selector);
    });
  }

  function shouldUseCurrentProductIdentity(element, keys) {
    if (!document.body.classList.contains('template--product')) {
      return false;
    }

    if (isWithinWiserFbt(element)) {
      return false;
    }

    var excludedSelectors = [
      '.ws-widget-section',
      '.ws_card_wrapper',
      '.ws_card',
      '.ws_inr_main_wgt',
      '.ws_fbt_wrap',
      '.cbb-also-bought-container',
      '.card--default',
      '.product-card',
      '.product-mini',
      '.st-product',
      '.snize-product',
      '.swymcs-wishlistplus-item',
    ];

    if (isWithinSelectorList(element, excludedSelectors)) {
      return false;
    }

    var includedSelectors = [
      '.product-gallery-block .swym-icon-text',
      '.product-gallery-block .swym-button-content .swym-icon-text',
      '.product-gallery-block .swym-atw-button-container.product_image_top_right .atw-button',
      '.product-gallery-block .swym-atw-button-container.product_image_top_right .atw-button-added',
      '.product__page--info .swym-icon-text',
      '.product__page--info .swym-button',
      '.product__page--info .swym-add-to-wishlist',
      '.product__page--info .swym-added-to-wishlist',
      '.product-form .swym-icon-text',
      '.product-form .swym-button',
      '.product-form .swym-add-to-wishlist',
      '.product-form .swym-added-to-wishlist',
      '.add-to-cart__sticky .swym-icon-text',
      '.add-to-cart__sticky .atw-button',
      '.add-to-cart__sticky .atw-button-added',
      '.sticky--mobile .swym-icon-text',
      '.sticky--mobile .atw-button',
      '.sticky--mobile .atw-button-added',
    ];

    if (includedSelectors.some(function (selector) {
      return !!element.matches(selector);
    })) {
      return true;
    }

    return !!element.closest('.product-gallery-block, .product__page--info, .product-form, .add-to-cart__sticky, .sticky--mobile');
  }

  function getProductKeys(element) {
    var identityScope = getClosestIdentityScope(element);
    var productContext = findNearbyProductContext(element);
    var datasets = collectAncestorDatasets(element, identityScope);

    if (productContext && productContext !== identityScope) {
      datasets = datasets.concat(collectAncestorDatasets(productContext, productContext));
    }

    var keys = {
      epis: [],
      empis: [],
      urls: [],
      handles: [],
    };

    collectCachedIdentityValues(element, keys, element);
    collectCachedIdentityValues(element, keys, identityScope);
    collectCachedIdentityValues(element, keys, productContext);
    collectCachedIdentityValues(element, keys, element.closest(BUTTON_CONTAINER_SELECTOR));

    datasets.forEach(function (dataset) {
      [
        dataset.epi,
        dataset.variantId,
        dataset.productVariantId,
        dataset.swymVariantId,
      ].forEach(function (value) {
        if (value != null && value !== '') {
          keys.epis.push(String(value));
        }
      });

      [
        dataset.empi,
        dataset.productId,
        dataset.swymProductId,
      ].forEach(function (value) {
        if (value != null && value !== '') {
          keys.empis.push(String(value));
        }
      });

      [
        dataset.du,
        dataset.url,
        dataset.productUrl,
        dataset.href,
      ].forEach(function (value) {
        var normalized = normalizeUrl(value);
        if (normalized) {
          keys.urls.push(normalized);
        }
      });
    });

    var linkedUrl = normalizeUrl(getClosestProductLink(element, identityScope));
    if (linkedUrl) {
      keys.urls.push(linkedUrl);
    }

    if (shouldUseCurrentProductIdentity(element, keys)) {
      keys.urls.push(normalizeUrl(window.location.href));

      if (window.SwymPageData) {
        if (window.SwymPageData.epi != null) {
          keys.epis.push(String(window.SwymPageData.epi));
        }

        if (window.SwymPageData.empi != null) {
          keys.empis.push(String(window.SwymPageData.empi));
        }
      }
    } else if (shouldUseProductPageFallback(element, keys)) {
      keys.urls.push(normalizeUrl(window.location.href));
    }

    keys.epis = Array.from(new Set(keys.epis.filter(Boolean)));
    keys.empis = Array.from(new Set(keys.empis.filter(Boolean)));
    keys.urls = Array.from(new Set(keys.urls.filter(Boolean)));
    keys.handles = Array.from(new Set(keys.urls.map(normalizeHandle).filter(Boolean)));

    cacheProductKeys(element, keys);

    return keys;
  }

  function isWishlisted(element, state) {
    var keys = getProductKeys(element);

    return keys.epis.some(function (value) {
      return !!state.epis[value];
    }) || keys.empis.some(function (value) {
      return !!state.empis[value];
    }) || keys.urls.some(function (value) {
      return !!state.urls[value];
    }) || keys.handles.some(function (value) {
      return !!state.handles[value];
    });
  }

  function hasMatchingProductKeys(firstKeys, secondKeys) {
    if (!firstKeys || !secondKeys) {
      return false;
    }

    return firstKeys.epis.some(function (value) {
      return secondKeys.epis.indexOf(value) >= 0;
    }) || firstKeys.empis.some(function (value) {
      return secondKeys.empis.indexOf(value) >= 0;
    }) || firstKeys.urls.some(function (value) {
      return secondKeys.urls.indexOf(value) >= 0;
    }) || firstKeys.handles.some(function (value) {
      return secondKeys.handles.indexOf(value) >= 0;
    });
  }

  function getRenderedButtonState(button) {
    var container = button.closest(BUTTON_CONTAINER_SELECTOR);
    var actionName = (
      button.getAttribute('data-swaction') ||
      button.dataset.swaction ||
      button.dataset.swymAction ||
      button.dataset.swymWishlistAction ||
      (container && (
        container.getAttribute('data-swaction') ||
        container.dataset.swaction ||
        container.dataset.swymAction ||
        container.dataset.swymWishlistAction
      )) ||
      ''
    ).toLowerCase();
    var actionState = actionName.indexOf('remove') >= 0 ? true : actionName.indexOf('add') >= 0 ? false : null;

    return isWishlisted(button, lastState) ||
      actionState === true ||
      button.dataset.swymSyncedState === 'wishlisted' ||
      button.classList.contains('swym-added-to-wishlist') ||
      button.classList.contains('atw-button-added') ||
      button.getAttribute('aria-pressed') === 'true' ||
      (container && container.dataset.swymSyncedState === 'wishlisted') ||
      (container && container.classList.contains('swym-added-to-wishlist')) ||
      (container && container.classList.contains('atw-button-added'));
  }

  function applyVisualButtonState(button, wishlisted) {
    if (!(button instanceof Element)) {
      return;
    }

    button.querySelectorAll('svg path').forEach(function (path) {
      path.style.fill = wishlisted ? 'currentColor' : 'none';
      path.style.stroke = 'currentColor';
    });
  }

  function applyVisualStateForMatchingButtons(sourceKeys, wishlisted) {
    if (!sourceKeys) {
      return;
    }

    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      var buttonKeys = getProductKeys(button);

      if (hasMatchingProductKeys(sourceKeys, buttonKeys)) {
        applyVisualButtonState(button, wishlisted);
      }
    });
  }

  function annotateButtonsWithProductContext() {
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);

    buttons.forEach(function (button) {
      var productContext = findNearbyProductContext(button);
      if (!productContext || !productContext.dataset) {
        return;
      }

      if (!button.dataset.swymResolvedEmpi && productContext.dataset.empi) {
        button.dataset.swymResolvedEmpi = String(productContext.dataset.empi);
      }

      if (!button.dataset.swymResolvedEpi && productContext.dataset.epi) {
        button.dataset.swymResolvedEpi = String(productContext.dataset.epi);
      }

      if (!button.dataset.swymResolvedDu && productContext.dataset.productUrl) {
        button.dataset.swymResolvedDu = productContext.dataset.productUrl;
      }

      var container = button.closest(BUTTON_CONTAINER_SELECTOR);
      if (container && container.dataset) {
        if (!container.dataset.swymResolvedEmpi && button.dataset.swymResolvedEmpi) {
          container.dataset.swymResolvedEmpi = button.dataset.swymResolvedEmpi;
        }

        if (!container.dataset.swymResolvedEpi && button.dataset.swymResolvedEpi) {
          container.dataset.swymResolvedEpi = button.dataset.swymResolvedEpi;
        }

        if (!container.dataset.swymResolvedDu && button.dataset.swymResolvedDu) {
          container.dataset.swymResolvedDu = button.dataset.swymResolvedDu;
        }
      }
    });
  }

  function getSwymActionName(wishlisted) {
    return wishlisted ? 'removeFromWishlist' : 'addToWishlist';
  }

  function updateActionAttributes(target, wishlisted) {
    if (!target || !target.setAttribute) {
      return;
    }

    var actionName = getSwymActionName(wishlisted);

    target.setAttribute('data-swaction', actionName);

    if (target.dataset) {
      target.dataset.swaction = actionName;
      target.dataset.swymAction = actionName;
      target.dataset.swymWishlistAction = wishlisted ? 'remove' : 'add';
    }

    target.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
    target.setAttribute('title', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function applyButtonState(button, wishlisted) {
    var container = button.closest(BUTTON_CONTAINER_SELECTOR);
    var productScope = findNearbyProductContext(button);
    var identityScope = getClosestIdentityScope(button);
    var paths = button.querySelectorAll('svg path');

    function applyStateToTarget(target) {
      if (!target || !target.classList) {
        return;
      }

      if (target.dataset) {
        target.dataset.swymSyncedState = wishlisted ? 'wishlisted' : 'not-wishlisted';
      }

      target.classList.toggle('is-wishlisted', wishlisted);
      target.classList.toggle('swym-added-to-wishlist', wishlisted);
      target.classList.toggle('swym-add-to-wishlist', !wishlisted);
      target.classList.toggle('atw-button-added', wishlisted);
      target.classList.toggle('atw-button', !wishlisted);
      updateActionAttributes(target, wishlisted);
    }

    button.classList.toggle('is-wishlisted', wishlisted);
    button.classList.toggle('swym-added-to-wishlist', wishlisted);
    button.classList.toggle('swym-add-to-wishlist', !wishlisted);
    button.classList.toggle('atw-button-added', wishlisted);
    button.classList.toggle('atw-button', !wishlisted);
    button.classList.toggle('swym-icon-text', button.classList.contains('swym-icon-text'));
    button.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    button.dataset.swymSyncedState = wishlisted ? 'wishlisted' : 'not-wishlisted';
    updateActionAttributes(button, wishlisted);

    applyStateToTarget(container);

    if (identityScope && identityScope !== container) {
      applyStateToTarget(identityScope);
    }

    if (productScope && productScope !== container && productScope !== identityScope) {
      if (productScope.dataset) {
        productScope.dataset.swymSyncedState = wishlisted ? 'wishlisted' : 'not-wishlisted';
      }
      productScope.classList.toggle('is-wishlisted', wishlisted);
    }

    paths.forEach(function (path) {
      path.style.fill = wishlisted ? 'currentColor' : 'none';
      path.style.stroke = 'currentColor';
    });
  }

  function updateButtonsFromState(state) {
    annotateButtonsWithProductContext();
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);
    buttons.forEach(function (button) {
      applyButtonState(button, isWishlisted(button, state));
    });
  }

  function updateHeaderCount(state) {
    var countEls = document.querySelectorAll(HEADER_COUNT_SELECTOR);
    countEls.forEach(function (node) {
      node.textContent = String(state.count);
      node.classList.toggle('show-badge', state.count > 0);
      node.style.display = state.count > 0 ? '' : 'none';
    });
  }

  function refreshPageState(swat, forceFetch) {
    refreshPlatformCollections();

    return fetchWishlistState(swat, { force: !!forceFetch }).then(function (state) {
      lastState = state;
      updateButtonsFromState(state);
      updateHeaderCount(state);
      return state;
    });
  }

  function notifyRemoteListeners(payload) {
    dispatch(payload);
    scheduleRefreshSequence([100, 550, 1300, 2400]);
  }

  function bindIncomingMessages() {
    window.addEventListener('storage', function (event) {
      if (event.key !== STORAGE_KEY || !event.newValue) {
        return;
      }

      try {
        notifyRemoteListeners(JSON.parse(event.newValue));
      } catch (error) {
        console.error('Failed to parse wishlist storage payload', error);
      }
    });

    if (channel) {
      channel.addEventListener('message', function (event) {
        if (event && event.data) {
          notifyRemoteListeners(event.data);
        }
      });
    }

    window.addEventListener('focus', function () {
      scheduleUiRefresh(true);
    });

    window.addEventListener('pageshow', function () {
      scheduleUiRefresh(true);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        scheduleUiRefresh(true);
      }
    });
  }

  function startPassiveRefreshLoop() {
    if (passiveRefreshInterval || !window._swat) {
      return;
    }

    passiveRefreshInterval = window.setInterval(function () {
      if (document.visibilityState !== 'visible') {
        return;
      }

      refreshPageState(window._swat, true);
    }, 4000);
  }

  function bindClickEmitFallback() {
    if (clickEmitFallbackBound) {
      return;
    }

    clickEmitFallbackBound = true;

    document.addEventListener(
      'click',
      function (event) {
        if (!(event.target instanceof Element)) {
          return;
        }

        var button = event.target.closest(BUTTON_SELECTOR);
        if (!button) {
          return;
        }

        var cachedKeys = getProductKeys(button);
        cacheProductKeys(button, cachedKeys);
        var nextWishlisted = !getRenderedButtonState(button);

        window.setTimeout(function () {
          applyVisualStateForMatchingButtons(cachedKeys, nextWishlisted);
        }, 0);

        window.setTimeout(function () {
          scheduleUiRefresh(true);
        }, 80);

        window.setTimeout(function () {
          scheduleUiRefresh(true);
          scheduleRefreshSequence([180, 700, 1500, 2800]);
        }, 180);
      },
      true
    );
  }

  function scheduleMutationRefresh() {
    clearTimeout(notifyTimer);
    notifyTimer = window.setTimeout(function () {
      refreshPlatformCollections();
      scheduleUiRefresh(true);
    }, 220);
  }

  function startObservers() {
    if (observersStarted || !document.body || typeof MutationObserver !== 'function') {
      return;
    }

    observersStarted = true;

    var observer = new MutationObserver(function (mutations) {
      var sawRelevantNode = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          if (!(node instanceof Element)) {
            return false;
          }

          return node.matches(BUTTON_SELECTOR + ', ' + HEADER_COUNT_SELECTOR + ', ' + PRODUCT_HOST_SELECTOR) ||
            !!node.querySelector(BUTTON_SELECTOR + ', ' + HEADER_COUNT_SELECTOR + ', ' + PRODUCT_HOST_SELECTOR);
        });
      });

      if (sawRelevantNode) {
        updateButtonsFromState(lastState);
        updateHeaderCount(lastState);
        scheduleMutationRefresh();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function emitAfterDelay(detail, delay) {
    window.setTimeout(function () {
      emit(detail);
    }, delay || 120);
  }

  function patchMethod(target, methodName, detailBuilder) {
    if (!target || typeof target[methodName] !== 'function' || target[methodName].__swymSyncWrapped) {
      return;
    }

    var originalMethod = target[methodName];

    target[methodName] = function () {
      var args = Array.prototype.slice.call(arguments);
      var callbackIndex = args.findIndex(function (arg) {
        return typeof arg === 'function';
      });
      var detail = Object.assign({ source: methodName }, detailBuilder ? detailBuilder(args) : {});

      if (callbackIndex >= 0) {
        var originalCallback = args[callbackIndex];
        args[callbackIndex] = function () {
          emitAfterDelay(detail, 120);
          return originalCallback.apply(this, arguments);
        };
      } else {
        emitAfterDelay(detail, 160);
      }

      return originalMethod.apply(this, args);
    };

    target[methodName].__swymSyncWrapped = true;
  }

  function patchMutationMethods() {
    if (methodsPatched || !window._swat) {
      return;
    }

    patchMethod(window._swat, 'addToWishList', function (args) {
      return Object.assign({ action: 'add' }, args[0] && typeof args[0] === 'object' ? { product: args[0] } : {});
    });

    patchMethod(window._swat, 'removeFromWishList', function (args) {
      return Object.assign({ action: 'remove' }, args[0] && typeof args[0] === 'object' ? { product: args[0] } : {});
    });

    patchMethod(window._swat, 'addToList', function (args) {
      return {
        action: 'add',
        listId: args[0],
        product: args[1],
      };
    });

    patchMethod(window._swat, 'deleteFromList', function (args) {
      return {
        action: 'remove',
        listId: args[0],
        product: args[1],
      };
    });

    methodsPatched = true;
  }

  function bindOutboundEvents(swat) {
    if (!swat || !swat.evtLayer || outboundBindings.has(swat.evtLayer)) {
      return;
    }

    outboundBindings.add(swat.evtLayer);

    swat.evtLayer.addEventListener('sw:addedtowishlist', function (event) {
      emit({
        source: 'sw:addedtowishlist',
        action: 'add',
        detail: event && event.detail,
        product: event && event.detail && typeof event.detail === 'object' ? event.detail : undefined,
      });
    });

    swat.evtLayer.addEventListener('sw:removedfromwishlist', function (event) {
      emit({
        source: 'sw:removedfromwishlist',
        action: 'remove',
        detail: event && event.detail,
        product: event && event.detail && typeof event.detail === 'object' ? event.detail : undefined,
      });
    });
  }

  function init(swat, onRemoteChange) {
    if (!swat) {
      return;
    }

    window._swat = window._swat || swat;

    if (typeof onRemoteChange === 'function' && remoteListeners.indexOf(onRemoteChange) === -1) {
      remoteListeners.push(onRemoteChange);
    }

    bindOutboundEvents(swat);
    patchMutationMethods();
    bindClickEmitFallback();
    startObservers();
    startPassiveRefreshLoop();
    refreshPlatformCollections();
    refreshPageState(swat, true);
    scheduleRefreshSequence([250, 900, 1800]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObservers);
  } else {
    startObservers();
  }

  bindIncomingMessages();

  window.SwymWishlistSync = {
    storageKey: STORAGE_KEY,
    eventName: EVENT_NAME,
    channelName: CHANNEL_NAME,
    emit: emit,
    dispatch: dispatch,
    init: init,
    refresh: function (forceFetch) {
      if (!window._swat) {
        return Promise.resolve(lastState);
      }

      return refreshPageState(window._swat, !!forceFetch);
    },
    refreshButtons: function (forceFetch) {
      if (!window._swat) {
        return Promise.resolve(lastState);
      }

      return refreshPageState(window._swat, !!forceFetch);
    },
    getState: function () {
      return lastState;
    },
  };

  window.SwymSync = window.SwymWishlistSync;
})();
